import React from 'react';
import styles from './A23GameIconButton.module.css';

export default function A23GameIconButton({children, onClick}) {
  return (
    <div onClick={onClick} className={styles.gameIconButtonContainer}>
        {children}
    </div>
  )
} 